import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import LanguageManager from "../../../../manager/language_manager";
import TimeManager from "../../../../manager/time_manager";
import ViewBase from "../../../../framework/core/mvvm/view_base";

const { ccclass, property } = cc._decorator;

@ccclass
export default class BagBufftem extends cc.Component{
    @property(cc.Sprite)
    itemIcon:cc.Sprite = null

    @property(cc.Label)
    itemName:cc.Label = null

    @property(cc.Label)
    itemInfo:cc.Label = null

    @property(cc.RichText)
    itemTime:cc.RichText = null

    @property(SpriteFrameHolder)
    iconSprHolder:SpriteFrameHolder = null

    timeId = null

    showBuffInfo(data, viewBase:ViewBase){
        if (this.timeId != null){
            viewBase.cancelSchedule(this.timeId)
            this.timeId = null
        }
        if (data == null){
            this.node.active = false 
            return 
        }
        let self = this
        this.node.active = true
        this.itemName.string = data.itemName
        this.itemInfo.string = data.itemDesc
        this.itemIcon.spriteFrame = this.iconSprHolder.getSpriteFrameByKey(data.itemCode)
        let timeStr = Math.floor((data.endTime/1000) - TimeManager.instance.getServerTime())
        if (timeStr > 86400){ //是否大于一天的
            this.itemTime.string = "<color=#55a64d>" + LanguageManager.t("hall_bag_time").format("<color=#d75229>" + Math.ceil(timeStr / 86400) + "</color>") + "</color>"
        }
        else{
            this.timeId = viewBase.doSchedule(()=>{
                timeStr -= 1
                if (timeStr <= 0){
                    self.itemTime.string = "<color=#c5815e>ยังไม่ใช้</color>"
                    return
                }
                let str = TimeManager.instance.getTimeLeft2BySecond(timeStr)
                self.itemTime.string = "<color=#55a64d>" + LanguageManager.t("hall_bag_minTime").format("<color=#d75229>" + str + "</color>") + "</color>"
            }, 1, timeStr)
        }
        
    }





}